enum Permission {
    S2S_Shipment_Creation = 'S2S_Shipment_Creation',
    PU_create = 'PU_create',
    PU_create_pickship = 'PU_create_pickship',
    PU_create_pickreturn = 'PU_create_pickreturn',
    S2S_CRUD_store = 'S2S_CRUD_store',
    S2S_Shipment_Overview_Read_only = 'S2S_Shipment_Overview_Read_only',
    Create_shipment = 'Create_shipment'
}

export { Permission };
